export const DEFAULT_VALIDITY_MONTHS = 12;

export const parseValidityMonths = (value) => {
  if (value == null || value === '') return DEFAULT_VALIDITY_MONTHS;
  const str = String(value).trim();
  if (/^\d{1,3}$/.test(str)) {
    const months = parseInt(str, 10);
    return months > 0 ? months : DEFAULT_VALIDITY_MONTHS;
  }
  return DEFAULT_VALIDITY_MONTHS;
};

export const calculateLicenseExpirationDate = (months, startDate = new Date()) => {
  const count = parseValidityMonths(months);
  const date = new Date(startDate);
  if (Number.isNaN(date.getTime())) return '';
  date.setMonth(date.getMonth() + count);
  return date.toISOString().split('T')[0];
};

export const formatValidityMonthsLabel = (months) => {
  const count = parseValidityMonths(months);
  return count === 1 ? '1 month' : `${count} months`;
};

export const getDefaultLicenseFields = () => {
  const validityPeriod = String(DEFAULT_VALIDITY_MONTHS);
  return {
    validityPeriod,
    licenseExpirationDate: calculateLicenseExpirationDate(validityPeriod),
  };
};
